import React from "react"
import {Layout} from "antd"

const {Footer} = Layout

export const MainFooter: React.FC = (): React.ReactElement =>
  <Footer style={{textAlign: "center", color: "rgba(0,0,0,.45)"}}>
    <p>User management console</p>
    <p>Copyright ©2022 Enersys</p>
  </Footer>